"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactCollapse = require("react-collapse");
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var _CssClassNames = new _CssClassNames2["default"](_stylesModule["default"], ['utility']),
  className = _CssClassNames.className;
var Accordion = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$initialShow = _ref.initialShow,
    initialShow = _ref$initialShow === void 0 ? 0 : _ref$initialShow,
    _ref$wrapperClassName = _ref.wrapperClassName,
    wrapperClassName = _ref$wrapperClassName === void 0 ? '' : _ref$wrapperClassName,
    _ref$itemClassName = _ref.itemClassName,
    itemClassName = _ref$itemClassName === void 0 ? '' : _ref$itemClassName,
    _ref$openItemClassNam = _ref.openItemClassName,
    openItemClassName = _ref$openItemClassNam === void 0 ? '' : _ref$openItemClassNam,
    _ref$titleClassName = _ref.titleClassName,
    titleClassName = _ref$titleClassName === void 0 ? '' : _ref$titleClassName,
    _ref$bodyClassName = _ref.bodyClassName,
    bodyClassName = _ref$bodyClassName === void 0 ? '' : _ref$bodyClassName,
    _ref$allShown = _ref.allShown,
    allShown = _ref$allShown === void 0 ? false : _ref$allShown,
    _ref$lock = _ref.lock,
    lock = _ref$lock === void 0 ? false : _ref$lock,
    _ref$onOpenItemChange = _ref.onOpenItemChange,
    onOpenItemChange = _ref$onOpenItemChange === void 0 ? function () {} : _ref$onOpenItemChange,
    _ref$itemProps = _ref.itemProps,
    itemProps = _ref$itemProps === void 0 ? {} : _ref$itemProps;
  var _useState = (0, _react.useState)(initialShow),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      openItem: function openItem(index) {
        if (index < items.length) {
          setShow(index);
          onOpenItemChange(index);
        }
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, className(wrapperClassName), {
    id: "accordion"
  }), items.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      key: i
    }, className("".concat(itemClassName, " ").concat(i === show || allShown || item.show ? "".concat(openItemClassName, " open") : '', " ").concat(item.className ? item.className : '')), itemProps && itemProps), /*#__PURE__*/_react["default"].createElement("button", _extends({}, className("w-100 d-block position-relative title ".concat(titleClassName, " ").concat(item.classNameTitle ? item.classNameTitle : '')), {
      type: "button",
      "data-toggle": "collapse",
      "data-lock": allShown || lock || item.lock || item.show,
      "data-target": "#collapse".concat(i),
      "aria-expanded": i === show || allShown || item.show ? 'true' : 'false',
      "aria-controls": "#collapse".concat(i),
      id: "heading".concat(i),
      onClick: function onClick(e) {
        e.stopPropagation();
        if (allShown || lock || item.lock || item.show) {
          return;
        }
        setShow(show === i ? null : i);
        onOpenItemChange(show === i ? null : i);
      }
    }), item.title), /*#__PURE__*/_react["default"].createElement(_reactCollapse.Collapse, {
      isOpened: i === show || allShown || item.show,
      id: "collapse".concat(i),
      "aria-labelledby": "heading".concat(i),
      "data-parent": "#accordion",
      theme: {
        collapse: className('collapse').className,
        content: bodyClassName
      }
    }, item.body));
  }));
});
exports.Accordion = Accordion;